module.exports = __webpack_public_path__ + "img/friend2.12ae2441.png";